/**
 * Draw overlay delegator.
 * Routes to 2D or 3D overlay renderers based on current map mode.
 */

import type { GeoPoint, DrawingTool } from '@vtak/shared';
import type { MapInstance, ViewMode } from '../map-setup';
import { showDrawOverlay2D, updateDrawOverlay2D, clearDrawOverlay2D } from './draw-overlay-2d';
import { showDrawOverlay3D, updateDrawOverlay3D, clearDrawOverlay3D } from './draw-overlay-3d';

/** Show or replace the draw overlay for the given vertices and tool */
export function showDrawOverlay(
  map: MapInstance,
  mode: ViewMode,
  vertices: GeoPoint[],
  tool: DrawingTool,
): void {
  if (mode === '2d') {
    showDrawOverlay2D(map as google.maps.Map, vertices, tool);
  } else {
    showDrawOverlay3D(map as google.maps.maps3d.Map3DElement, vertices, tool);
  }
}

/** Update the existing draw overlay with new vertices */
export function updateDrawOverlay(
  map: MapInstance,
  mode: ViewMode,
  vertices: GeoPoint[],
  tool: DrawingTool,
): void {
  if (mode === '2d') {
    updateDrawOverlay2D(map as google.maps.Map, vertices, tool);
  } else {
    updateDrawOverlay3D(map as google.maps.maps3d.Map3DElement, vertices, tool);
  }
}

/** Remove all draw overlay elements */
export function clearDrawOverlay(mode: ViewMode): void {
  if (mode === '2d') {
    clearDrawOverlay2D();
  } else {
    clearDrawOverlay3D();
  }
}
